/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Invite_Setroles2Inputs */

const en_usermanagement_invite_setroles2 = /** @type {(inputs: Usermanagement_Invite_Setroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set roles`)
};

/**
* | output |
* | --- |
* | "Set roles" |
*
* @param {Usermanagement_Invite_Setroles2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_invite_setroles2 = /** @type {((inputs?: Usermanagement_Invite_Setroles2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Invite_Setroles2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_invite_setroles2(inputs)
});
export { usermanagement_invite_setroles2 as "userManagement_invite_setRoles" }